const KEY_PREFIX = 'g2'

const handleArrays = (key, val, connectingChar = ',') => {
  const brokenObject = {}

  let count = 1
  let ptr = 0

  while (ptr < val.length) {
    let acceptedStr = val[ptr++]
    while (ptr < val.length && acceptedStr.length + connectingChar.length + val[ptr].length <= 500) {
      acceptedStr = `${acceptedStr}${connectingChar}${val[ptr++]}`
    }

    const currKey = `${key}_${count++}`
    brokenObject[currKey] = acceptedStr
  }

  return brokenObject
}

const handleLongString = (key, val) => {
  const wordsList = val.split(' ')
  return handleArrays(key, wordsList, ' ')
}

export const normalizeResponse = (response, keyPrefix = KEY_PREFIX) => {
  if (!response) return {}
  let normalized = {}

  for (const rawKey of Object.keys(response)) {
    const val = response[rawKey]
    const key = `${keyPrefix}_${rawKey}`

    if (val == null) continue

    if (rawKey === 'description') {
      normalized = { ...normalized, ...handleLongString(key, val) }
    } else if (['number', 'string', 'boolean'].includes(typeof val)) {
      normalized[key] = val
    } else if (Array.isArray(val)) {
      normalized = { ...normalized, ...handleArrays(key, val) }
    } else {
      normalized = {
        ...normalized,
        ...normalizeResponse(val, `${keyPrefix}_${rawKey}`),
      }
    }
  }

  return normalized
}

export const handleG2Enrich = response => {
  const { data, ...companyData } = response?.company ?? {}

  const normalizedCompanyData = normalizeResponse(companyData, `${KEY_PREFIX}_c`)

  const normalizedData = normalizeResponse(data)

  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: 'g2_company_lookup',
    ...normalizedData,
    ...normalizedCompanyData,
  })
}
